export const COOKIES_NAME_PREFIX = 'prox_resp_jwt_token_';
export const TOKEN_TYPE_FINALIZACAO = 'FINALIZACAO';
